import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Input } from "./ui/input";
import { Button } from "./ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function ForgotPassword({ initialEmail, onBack }) {
  const [email, setEmail] = useState(initialEmail || "");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return toast.error("Inserisci la tua email");
    setBusy(true);
    try {
      const r = await fetch(`${API}/web/forgot-password`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ email: email.trim() }) });
      if (!r.ok) throw new Error((await r.json().catch(() => ({}))).detail || "Richiesta non riuscita, riprova");
      setSent(true);
    } catch (err) { toast.error(err.message); }
    finally { setBusy(false); }
  };

  return (
    <form onSubmit={submit} className="w-full max-w-sm fade-up" data-testid="forgot-form">
      <h2 className="font-display text-3xl font-bold text-white mb-2">Password dimenticata</h2>
      {sent ? (
        <p className="text-white/70 text-sm mb-8" data-testid="forgot-sent-text">Se l'email è registrata, riceverai a breve un link per scegliere una nuova password. Il link vale 60 minuti. Controlla anche la cartella spam.</p>
      ) : (
        <>
          <p className="text-white/50 text-sm mb-8">Inserisci la tua email: ti invieremo un link per reimpostare la password.</p>
          <label className="text-sm text-white/70">Email</label>
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="nome@portoturisticodiroma.it" className="mt-1.5 mb-8 h-12 bg-white/5 border-white/15 text-white placeholder:text-white/30" data-testid="forgot-email-input" />
          <Button type="submit" disabled={busy} className="w-full h-12 rounded-full bg-[var(--teal)] hover:bg-[#257474] text-white font-semibold" data-testid="forgot-submit-button">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Invia link"}
          </Button>
        </>
      )}
      <button type="button" onClick={onBack} className="block mx-auto mt-6 text-sm text-white/60 hover:text-white underline" data-testid="forgot-back-button">Torna all'accesso</button>
    </form>
  );
}
